import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import { useDispatch, sendFlashMessage } from '@/shared/components/flash';
import ApiErrorMessage from '@/shared/components/ApiErrorMessage';
import ConfirmDeleteModal from './ConfirmDeleteModal';

const CategoryIndexDataTable = ({ organization }) => {
    const dispatch = useDispatch();

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [deleteTarget, setDeleteTarget] = useState(null);

    const fetchData = useCallback(async () => {
        if (!organization?.id) return;
        try {
            const result = await axios.get(`/organization/${organization.id}/category`);
            setCategories(result.data.categories || []);
        } catch (error) {
            dispatch(sendFlashMessage(<ApiErrorMessage errors={error.response?.data} />, 'alert-danger'));
        } finally {
            setLoading(false);
        }
    }, [dispatch, organization?.id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const onConfirmDelete = async () => {
        if (!deleteTarget) return;
        try {
            await axios.delete(`/organization/${organization.id}/category/${deleteTarget.id}`);
            dispatch(sendFlashMessage('Category deleted successfully', 'alert-success'));
            setDeleteTarget(null);
            fetchData();
        } catch (error) {
            setDeleteTarget(null);
            dispatch(sendFlashMessage(<ApiErrorMessage errors={error.response?.data} />, 'alert-danger'));
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div>
            <div className="form form--horizontal">
                <div className="form__form-group pb-4">
                    <div className="col-md-2 col-lg-2 text-right pr-0" style={{ marginLeft: 'auto' }}>
                        <Link
                            style={{ maxWidth: '200px' }}
                            className="btn btn-success account__btn account__btn--small"
                            to="/categories/add"
                        >
                            Add Category
                        </Link>
                    </div>
                </div>
            </div>
            <table className="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Keywords</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {categories.map(category => (
                        <tr key={category.id}>
                            <td>{category.name}</td>
                            <td>{(category.keywords || []).map(k => k.keyword).join(', ')}</td>
                            <td>
                                <Link to={`/categories/edit/${category.id}`}>Edit</Link>
                                <span style={{ width: '15px', display: 'inline-block' }} />
                                <Link
                                    to="#delete-category"
                                    className="text-danger"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setDeleteTarget(category);
                                    }}
                                >
                                    Delete
                                </Link>
                            </td>
                        </tr>
                    ))}
                    {categories.length === 0 && (
                        <tr>
                            <td colSpan={3}>No categories found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <ConfirmDeleteModal
                isOpen={!!deleteTarget}
                message={deleteTarget ? `Are you sure you want to delete "${deleteTarget.name}"?` : ''}
                onCancel={() => setDeleteTarget(null)}
                onConfirm={onConfirmDelete}
            />
        </div>
    );
};

export default connect(state => ({
    organization: state.organization
}))(CategoryIndexDataTable);
